import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import login from '@/components/login'
import improving from '@/components/improving'
import register from '@/components/register'
import memberCenter from '@/components/memberCenter'
import creatOrder from '@/components/creatOrder'
import myOrder from '@/components/myOrder'
import afterSale from '@/components/afterSale'
import score from '@/components/score'
import salary from '@/components/salary'
import registerMsg from '@/components/registerMsg'
import setpsword from '@/components/setpsword'
import orderDetail from '@/components/orderDetail'
import communicate from '@/components/communicate'
import news from '@/components/news'
import help from '@/components/help'

Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			redirect: '/login'
		},
		{
			path: '/',
			name: 'index',
			component: index,
			children: [{
					path: '/memberCenter',
					component: memberCenter,
					meta: {
						keepAlive: false,
					}
				}, {
					path: '/lobby',
					name: 'lobby',
					component: creatOrder,
					meta: {
						keepAlive: false,
					}
				},
				{
					path: '/myOrder',
					name: 'myOrder',
					component: myOrder,
					meta: {
						keepAlive: false,
					}
				},
				{
					path: '/afterSale',
					name: 'afterSale',
					component: afterSale,
					meta: {
						keepAlive: false,
					}
				},
				{
					path: '/score',
					name: 'score',
					component: score,
					meta: {
						keepAlive: false,
					}
				},
				{
					path: '/salary',
					name: 'salary',
					component: salary,
					meta: {
						keepAlive: false,
					}
				},
				{
					path: '/registerMsg',
					name: 'registerMsg',
					component: registerMsg,
					meta: {
						keepAlive: true,
					}
				},
				{
					path: '/setpsword',
					name: 'setpsword',
					component: setpsword,
					meta: {
						keepAlive: true,
					}
				}, {
					path: '/orderDetail',
					name: 'orderDetail',
					component: orderDetail,
					meta: {
						keepAlive: false,
					}
				}, {
					path: '/communicate',
					name: 'communicate',
					component: communicate,
					meta: {
						keepAlive: false,
					}
				}, {
					path: '/news',
					name: 'news',
					component: news,
					meta: {
						keepAlive: false,
					}
				},
			]
		},
		{
			path: '/help',
			name: 'help',
			component: help
		},
		{
			path: '/register',
			name: 'register',
			component: register
		},
		{
			path: '/improving',
			name: 'improving',
			component: improving
		},
		{
			path: '/login',
			name: 'login',
			component: login
		},
		{
			path: '*',
			redirect: '/login'
		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js